import { forwardRef, useCallback, useEffect, useState } from "react";
import { Link, useNavigate, LinkProps, To } from "react-router-dom";

interface DelayLinkProps extends LinkProps {
  delay: number;
  onDelayStart?: (e: PointerEvent, to: To) => void;
  onDelayEnd?: () => void;
}

export const DelayLink: React.FC<DelayLinkProps> = forwardRef(
  (props, ref: any) => {
    const [isTimeOut, setIsTimeout] = useState(false);
    const navigate = useNavigate();
    const {
      replace,
      to,
      delay,
      onDelayStart,
      onDelayEnd,
      children,
      className,
    } = props;

    const handleClick = useCallback(
      (e) => {
        if (onDelayStart) {
          onDelayStart(e, to);
        }
        if (e.defaultPrevented) {
          return;
        }
        e.preventDefault();
        setIsTimeout(true);
      },
      [to, onDelayStart]
    );

    useEffect(() => {
      if (isTimeOut) {
        let delayTimeOut = setTimeout(() => {
          if (replace) {
            navigate(to, { replace });
          } else {
            navigate(to);
          }
          if (onDelayEnd) {
            onDelayEnd();
          }
        }, delay);

        return () => clearTimeout(delayTimeOut);
      }
    }, [delay, navigate, onDelayEnd, replace, to, isTimeOut]);

    return (
      <Link
        to={to}
        onClick={handleClick}
        replace={replace}
        ref={ref}
        className={className}
      >
        {children}
      </Link>
    );
  }
);
